import { useTranslation } from 'react-i18next';
import { Typography } from '@figure/frontlib-gui';
import ReviewAppBase from '../components/ReviewAppBase';

const AppReviewContainer = () => {
  const { t } = useTranslation();
  const customerServiceNumber = t('phone.customerService');
  return (
    <ReviewAppBase>
      <Typography.Body>
        Your application is being reviewed by our Customer Support team. Please be advised that we
        will initiate funding of your loan once review is complete if no further action from you is
        required.
      </Typography.Body>
      <br />
      <Typography.Body>
        Our team will be in touch, or to expedite the process, you can contact us at{' '}
        {customerServiceNumber}. We are available Monday - Sunday 6am - 6pm Pacific time, except for
        major U.S. holidays.
      </Typography.Body>
    </ReviewAppBase>
  );
};

export default AppReviewContainer;
